import { useGetIssueTypeNamesQuery } from "graphqlBase/issue/__generated__/getIssueTypeNames";
import { useGetTenantsWithCertificatesToValidateQuery } from "graphqlBase/opentTaskListFilters/__generated__/getTenantsWithCertificatesToValidate";
import { useGetUserInfo } from "lib/userInfo";
import { useEffect } from "react";
import { atom, useSetRecoilState } from "recoil";
import useGetTenantNameById from "utils/useGetTenantNameById";

export type FilterItemStrings = {
  key: string;
  value: string;
};

export const tenantNameAtom = atom<FilterItemStrings[] | undefined>({
  key: "tenantNameAtom",
  default: [],
});
export const issueTypeNamesAtom = atom<FilterItemStrings[] | undefined>({
  key: "issueTypeNamesAtom",
  default: [],
});

export default () => {
  const userInfo = useGetUserInfo();
  const { tenantNameById } = useGetTenantNameById({ withDeniedTenants: true });
  const { data: issueTypeNamesData } = useGetIssueTypeNamesQuery();
  const setIssueTypeNames = useSetRecoilState(issueTypeNamesAtom);
  const setTenantNameAtom = useSetRecoilState(tenantNameAtom);
  const isPlatformOperator = userInfo?.role === "PLATFORM_OPERATOR";
  const { data: certificateHolderData } = useGetTenantsWithCertificatesToValidateQuery({
    variables: {
      where: {
        or: [
          {
            issueStatus: {
              issueStatusName: {
                or: [
                  {
                    eq: "Open",
                  },
                  {
                    eq: "Reopened",
                  },
                ],
              },
            },
          },
          {
            and: [
              { issueStatus: { issueStatusName: { eq: "Rejected" } } },
              { issueType: { issueTypeName: { neq: "Error Report" } } },
            ],
          },
          {
            and: [
              { issueStatus: { issueStatusName: { eq: "Acknowledged" } } },
              { issueType: { issueTypeName: { eq: "Error Report" } } },
            ],
          },
        ],
        // Platform Operators see all tenants — omit the assignedToTenantId restriction for them
        ...(!isPlatformOperator && {
          assignedToTenantId: {
            eq: userInfo?.tenantId,
          },
        }),
      },
    },
  });

  useEffect(() => {
    const uniqueManufacturerIds = Array.from(
      new Set(certificateHolderData?.issues?.items?.map((item) => item.certificate?.certificateHolderId))
    );

    setTenantNameAtom(
      uniqueManufacturerIds.map((id) => {
        return {
          key: id ?? "",
          value: tenantNameById[id] ?? "",
        };
      })
    );
  }, [certificateHolderData?.issues?.items, setTenantNameAtom, tenantNameById]);

  useEffect(() => {
    setIssueTypeNames(issueTypeNamesData?.issueTypes?.items ?? []);
  }, [issueTypeNamesData?.issueTypes?.items, setIssueTypeNames]);

  return null;
};
